import React, { useState } from "react";
// import { Protected } from "@/components/layout/Protected";
import {
   Button,
   Grid,
   IconButton,
   InputBase,
   SelectChangeEvent,
   Modal,
   Paper,
   Typography,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Props } from "../AllProducts.type";
import "../AllProducts_style.css";
import CloseIcon from "@mui/icons-material/Close";
import { FormControl } from "@mui/material";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from "@mui/icons-material/Search";

import Box from "@mui/material/Box";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import LocationOnIcon from "@mui/icons-material/LocationOn";

interface Column {
   id: "rut" | "razonSocial" | "fantasia" | "giro";
   label: string;
   minWidth?: number;
   align?: "right";
   format?: (value: number) => string;
}
const columns: readonly Column[] = [
   { id: "rut", label: "Barra", minWidth: 100 },
   { id: "razonSocial", label: "Razon Social", minWidth: 50 },
   { id: "fantasia", label: "Fantasia", minWidth: 50 },
   { id: "giro", label: "Giro", minWidth: 50 },
];
interface Data {
   rut: string;
   razonSocial: string;
   fantasia: string;
   giro: string;
}

function createData(
   rut: string,
   razonSocial: string,
   fantasia: string,
   giro: string
): Data {
   return { rut, razonSocial, fantasia, giro };
}

const rowsData = [
   createData("12345678-9", "Razon Social 1", "Fantasia 1", "$1.00"),
   createData("12345678-9", "Razon Social 2", "Fantasia 2", "$1.00"),
   createData("12345678-9", "Razon Social 3", "Fantasia 3", "$1.00"),
   createData("12345678-9", "Razon Social 4", "Fantasia 4", "$1.00"),
   createData("12345678-9", "Razon Social 5", "Fantasia 5", "$1.00"),
];

export const ModalPruebados: React.FC<Props> = (props: Props): JSX.Element => {
   const [open, setOpen] = useState(false);
   const handleClose = () => setOpen(false);

   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [ejecutivoComercial, setEjecutivoComercial] = useState("");
   const [estado, setEstado] = useState("");
   const [loading, setLoading] = useState(false);

   const handleChangeEjecutivoComercial = (event: SelectChangeEvent) => {
      setEjecutivoComercial(event.target.value);
   };
   const handleChangeEstado = (event: SelectChangeEvent) => {
      setEstado(event.target.value);
   };
   function handleClick() {
      setLoading(true);
   }

   const handleChangePage = (event: unknown, newPage: number) => {
      setPage(newPage);
   };

   const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement>
   ) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
   };

   const estados = [
      { label: "No Adjudicada", value: "Enviado" },
      { label: "Adjudicada", value: "Adjudicada" },
      { label: "Anulada", value: "No Adjudicada" },
   ];

   const style = {
      position: "absolute" as "absolute",
      top: "50%",
      left: "50%",
      height: "500px",
      transform: "translate(-50%, -50%)",
      width: "700px",
      borderRadius: "10px",
      bgcolor: "background.paper",
      boxShadow: "rgba(100,100,111,0.2) 0px 7px 29px 0px",
      p: 3,
      background: "#F5F5F5",
   };

   return (
      <Grid container p={2} sx={style}>
         <Grid item xs={12} md={12}>
            <Box>
               <Typography
                  variant="h6"
                  component="h1"
                  gutterBottom
                  className="tittle"
               >
                  LISTA DE CLIENTES POR RUT
               </Typography>
            </Box>
            <Box>
               <Typography variant="subtitle2" gutterBottom>
                  Seleccionar Cliente
               </Typography>
            </Box>

            <Paper sx={{ overflow: "hidden" }}>
               <TableContainer sx={{ maxHeight: 440 }}>
                  <Table stickyHeader aria-label="sticky table">
                     <TableHead>
                        <TableRow>
                           <TableCell>
                              <TextField
                                 id="outlined-basic"
                                 label="Rut"
                                 size="small"
                                 fullWidth
                              ></TextField>
                           </TableCell>

                           <TableCell>
                              <TextField
                                 id="outlined-basic"
                                 label="Razon Social"
                                 size="small"
                                 fullWidth
                              ></TextField>
                           </TableCell>

                           <TableCell>
                              <TextField
                                 id="outlined-basic"
                                 label="Fantasia"
                                 size="small"
                                 fullWidth
                              ></TextField>
                           </TableCell>

                           <TableCell>
                              <TextField
                                 id="outlined-basic"
                                 label="Giro"
                                 size="small"
                                 fullWidth
                              ></TextField>
                           </TableCell>
                        </TableRow>
                     </TableHead>
                     <TableBody>
                        {rowsData
                           .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                           )
                           .map((row) => {
                              return (
                                 <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.rut}
                                 >
                                    {columns.map((column) => {
                                       const value = row[column.id];
                                       return (
                                          <TableCell
                                             key={column.id}
                                             align={column.align}
                                          >
                                             {column.format &&
                                             typeof value === "number"
                                                ? column.format(value)
                                                : value}
                                          </TableCell>
                                       );
                                    })}
                                 </TableRow>
                              );
                           })}
                     </TableBody>
                  </Table>
               </TableContainer>
               <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={rowsData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            </Paper>
         </Grid>
      </Grid>
   );
};
